import { render } from "./SelectLang.vue?vue&type=template&id=b00d7b4a&scoped=true"
import script from "./SelectLang.vue?vue&type=script&lang=js"
export * from "./SelectLang.vue?vue&type=script&lang=js"

import "./SelectLang.vue?vue&type=style&index=0&id=b00d7b4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b00d7b4a"]])

export default __exports__